import { RestfulClient } from '@benzinga/session';
import { Session } from '@benzinga/session';
import { SafePromise } from '@benzinga/safe-await';
import { DataFieldIngress } from './entities';
import { QuotesV3FieldsEnvironment } from './environment';

export class QuotesV3FieldsRestful extends RestfulClient {
  constructor(session: Session) {
    super(session.getEnvironment(QuotesV3FieldsEnvironment).url, session, { 'x-device-key': true });
  }

  getScannerDefs = async (): SafePromise<DataFieldIngress> => {
    const url = this.URL(this.session.getEnvironment(QuotesV3FieldsEnvironment).url.toString());
    return this.get<DataFieldIngress>(url, { allowsAnonymousAuth: true, credentials: 'omit' });
  };
}
